export default __webpack_public_path__ + "cce6fad3d086cf7f171bc9ef3c388c84.png";